import { FC } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { OnboardingTasksV2 } from '@frontend/api-onboarding-tasks';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { isTaskCompleted } from '../../utils';
import { ModuleTasksCard, ModuleTasksCardLoader } from './module-tasks-card';
import { ModuleTasksCardCompact } from './module-tasks-card-compact';

interface ModuleTasksCardListProps {
  containerStyles?: Interpolation<Theme>;
  moduleTasks: OnboardingTasksV2.Types.ModuleRow[];
}
export const ModuleTasksCardList: FC<ModuleTasksCardListProps> = ({ containerStyles, moduleTasks }) => {
  return (
    <ul css={[styles.container, styles.listContainer, containerStyles]}>
      {moduleTasks.map((module) => (
        <ModuleTasksCard as='li' module={module} key={module.id} />
      ))}
    </ul>
  );
};

export const ModuleTasksCardListLoader: FC<{ containerStyles?: Interpolation<Theme>; count?: number }> = ({
  containerStyles,
  count = 3,
}) => {
  return (
    <ul css={[styles.container, styles.listContainer, containerStyles]}>
      {Array.from({ length: count }).map((_, index) => (
        <ModuleTasksCardLoader as='li' key={index} />
      ))}
    </ul>
  );
};

interface IncompleteModuleTasksCompactCardsProps {
  maxCount?: number;
  moduleTasks: OnboardingTasksV2.Types.ModuleRow[];
}
export const IncompleteModuleTasksCompactCards: FC<IncompleteModuleTasksCompactCardsProps> = ({
  moduleTasks,
  maxCount = 3,
}) => {
  const incompleteModules = moduleTasks.filter((module) => module.tasks.some((task) => !isTaskCompleted(task)));
  const limitedModules = incompleteModules.slice(0, maxCount);

  return (
    <ul css={[styles.compactContainer, styles.listContainer]}>
      {limitedModules.map((module) => (
        <ModuleTasksCardCompact as='li' module={module} key={module.id} />
      ))}
    </ul>
  );
};

const styles = {
  listContainer: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  compactContainer: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, 320px);
    align-items: center;
    gap: ${theme.spacing(2)};
    @container (max-width: ${breakpoints.small.min}px) {
      grid-template-columns: repeat(auto-fill, minmax(min-content, 100%));
    }
  `,
};
